import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  Autocomplete,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import CloseIcon from "@mui/icons-material/Close";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  TruckDetailsGetrow,
  TruckDriverDetailsGetrow,
  WMLDLSTA_TruckDriver_Update,
  WMLDLSTATruck_Getrow,
} from "../../../Server/ApiV2";
import "./UpdatedTruck.css";
import { RoLoadingLists } from "../../../Redux/roStore";
import { Set_LoadingList_HeadObject_Set } from "../SliceLoadingList";
const UpdatedTruck = ({
  xOpen = false,
  CloseUpdatedTruckModal,
  vRdxWmsHead,
  xTitle = "Updated Truck",
  fNewDetail = () => {},
  dispatch = () => {},
  sTruckArr = [],
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const vMediaQuery = useMediaQuery("(max-width: 1024px)");

  const formData = {
    truck: "",
    driver:"",
    driverName:"",
    CBM:"",
  };

  const [masterData, setMasterData] = useState(formData);

  const handleUpdate = async () => {
    const { HeadObject } = RoLoadingLists();
    if (
      masterData?.truck === "" ||
      masterData?.truck === null ||
      masterData?.truck === undefined
    ) {
      fAlertToast("FAILED", "truck should not be empty");
      return;
    } else if (
      masterData?.driver=== "" ||
      masterData?.driver === null ||
      masterData?.driver === undefined
    ) {
      fAlertToast("FAILED", "Driver name should not be empty");
      return;
    }
    const obj = {
      VocTyp: vRdxWmsHead?.A_VocTyp,
      VocNo: vRdxWmsHead?.A_VocNo,
      Truck: masterData?.truck,
      Driver: masterData?.driver,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const UpdateRes = await WMLDLSTA_TruckDriver_Update(FinalObj);

    if (UpdateRes?.status === 200) {
      fAlertToast("SUCCESS", "Updated Successfully");
      dispatch(
        Set_LoadingList_HeadObject_Set({
          ...HeadObject,
          Truck: masterData?.truck,
          Driver: masterData?.driver,
          DriverName: masterData?.driverName,
          TruckCBM: masterData?.CBM,
        })
      );
      setMasterData(formData);
      CloseUpdatedTruckModal();
    }
  };

   
useEffect(() => {
  if(xOpen){

    setMasterData({
      truck: vRdxWmsHead.Truck,
      driver: vRdxWmsHead.Driver,
      driverName: vRdxWmsHead.DriverName,
      CBM: vRdxWmsHead.TruckCBM,
    });
  }
},[xOpen])
  return (
    <div>
      <Modal
        open={xOpen}
        onClose={CloseUpdatedTruckModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <div className="p-2">
            <div
              style={{
                height: "auto",
                overFlowY: "auto",
                width: isMobile ? "95%" : "25%",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "var(--commonText)",
                border: "1px solid var(--primary)",
                boxShadow: "24px 24px 48px rgba(80, 40, 40, 0.1)",
                borderRadius: "10px",
              }}
            >
              <GCTitleSticky title={xTitle} onClose={CloseUpdatedTruckModal} />
              <div>
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ padding:4 }}
                >
                  <Grid item xs={6} sm={6} md={6} lg={12}>
                    <Typography>Voucher Type</Typography>
                    <CmpTextFieldV1
                      xLabelText=""
                      xValue={vRdxWmsHead?.A_VocTypName}
                      xType={"text"} // text/number/password
                      xName={"VocType"}
                      xReadOnly={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={12}>
                    <Typography>Voucher No</Typography>
                    <CmpTextFieldV1
                      xLabelText=""
                      xValue={vRdxWmsHead?.A_VocNo}
                      xType={"text"} // text/number/password
                      xName={"VocNo"}
                      xReadOnly={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={12}>
                    <Typography>Truck ID</Typography>
                    <Autocomplete
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          padding: "3px !important",
                        },
                        "& .MuiInputBase-input": {
                          padding: "5.5px 10px !important",
                        },
                      }}
                      freeSolo
                      id="free-solo-2-demo"
                      disableClearable
                      options={sTruckArr}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option || ""
                          : option?.Name1 || ""
                      }
                      value={
                        sTruckArr?.find(
                          (truck) => truck?.UId === masterData?.truck
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        let vTruckObj = sTruckArr.find((obj) => {
                          return obj.UId === newValue.UId;
                        });
                        setMasterData((prevV) => ({
                          ...prevV,
                          truck: newValue.UId,
                          driver: vTruckObj.Driver,
                          driverName: vTruckObj.DriverName,
                          CBM: vTruckObj.CBM,
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          slotProps={{
                            input: {
                              ...params.InputProps,
                              type: "search",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={12}>
                    <Typography>Driver</Typography>
                    <CmpTextFieldV1
                      xLabelText=""
                      xValue={masterData?.driverName}
                      xType={"text"} // text/number/password
                      xName={"Driver"}
                      xReadOnly={true}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        width: isMobile ? "75px" : "100px",
                        height: "35px",
                        mt: 2,
                        textTransform: "capitalize",
                      }}
                      // disabled={isEditing}
                      onClick={(e) => {
                        handleUpdate();
                      }}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default UpdatedTruck;
